import ProfileSecurity from 'components/Profile/components/ProfileSecurity/ProfileSecurity';
import { FC } from 'react';

const ProfileSecurityPage: FC = () => {
	return <ProfileSecurity />;
};

export default ProfileSecurityPage;
